import styled from 'styled-components';

export const Container = styled.div<any>`
  position: relative;
`;

export const Form = styled.div<any>`
  position: relative;
  width: auto;
  //margin: auto;
  //padding: 2em;
  //border: 1px solid ${(props) =>
    props.theme.name === 'light' ? '#d8d1d1' : 'grey'};
  border-radius: 5px;
  //margin-top: 100px;
  max-width: 20%;
  margin-top: 5%;
  background: transparent;
`;

export const Logo = styled.img`
  width: 5em;
  display: block;
  margin: auto;
`;
